import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';
@Injectable() export class CommonHttpService {
    constructor(public http: HttpClient, public errorService: ErrorService, private handler: HttpBackend) { }


    /////////////////////////////////get state /////////////////////////////////////////////////////////////////////////

    getJSON(): Observable<any> {
        let httpLocal = new HttpClient(this.handler);
        return httpLocal.get("./assets/states.json");
    }

    ////////////////////////////getPayorDropDown////////////////////
    getPayorDropDown(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
        let url = "api/GroupPayor/CommonGetGPList?";
        return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    ////////////////////////////////////////getcompany////////////////////////////////
    getCompany(): Observable<[{ Key: string, Value: string }]> {
        let url = "api/Company/CommonGetCompanyList?";
        return this.http.get<[{ Key: string, Value: string }]>(url , { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////getdclist///////////////////////////////////
    getDC(): Observable<[{ Key: number, Value: string }]> {
        let url = "api/Client/CommonGetDCList?";
        return this.http.get<[{ Key: number, Value: string }]>(url , { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////////getlovdropdown////////////////////////////
    getStatus(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
        let url = "api/LOV/getLovDropDown?"
        return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////////////getICD10////////////////////////////////////////
    getICD10(): Observable<[{ Key: number, Value: string }]> {
        let url = "api/Client/commonICDList"

        return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    ////////////////////////////////////////getStartofCareListdate/////////////////////////
    getStartofCareListdate(params): Observable<any> {
        let url = "api/StartOfCare/GetStartOfCareDate?"
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    getcompanyidofsoc(socId) {
        let url = "api/StartOfCare/GetCompanyofSoc?";
        let param = new URLSearchParams();
        param.append("socId", socId);
        return this.http.get<any>(url + param).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    GetAllEmployeesDropDownbyAgency(locId) {
        let url = "api/Employee/GetAllEmployeesDropDownbyAgency?";
        let params = new URLSearchParams();
        params.append("LocationId", locId);
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    GetAllClientsDropDownbyAgency(locId): Observable<any> {
        let url = "api/Client/GetAllClientsDropDownbyAgency?";
        let params = new URLSearchParams();
        params.append("LocationId", locId);
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

      /////////////////////////////////get state /////////////////////////////////////////////////////////////////////////

      getFeaturesJSON(): Observable<any> {
        let httpLocal = new HttpClient(this.handler);
        return httpLocal.get("./assets/Features.json");
    }

    getpermission(paramsData: URLSearchParams): Observable<any> {
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }

      GetAllEmployeesDropdown(): Observable<any> {
        let url = "api/Employee/GetAllEmployeesDropdown?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
    }


    GetAllClientDropDown(): Observable<any> {
        let url = "api/Client/GetAllClientDropDown?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
       )
    }



  

}
